import React from 'react'

type ScreenSizeContext = {
  width: number,
  height: number,
}

export default React.createContext<ScreenSizeContext>({
  width: 0,
  height: 0,
})